import { render } from "./TopNavBar.vue?vue&type=template&id=5e4c8066&scoped=true"
import script from "./TopNavBar.vue?vue&type=script&lang=js"
export * from "./TopNavBar.vue?vue&type=script&lang=js"

import "./TopNavBar.vue?vue&type=style&index=0&id=5e4c8066&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e4c8066"]])

export default __exports__